import { CustomSlot } from "@elixir/types";
import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

export default async function getBusinessCustomSlotsV2({
  startTime,
  endTime,
  slotDuration,
  docId,
  clinicId,
  slotsFromCalendar,
  mode,
}: {
  startTime: string;
  endTime: string;
  slotDuration: number;
  docId: string;
  clinicId: string;
  slotsFromCalendar?: boolean;
  mode?: "in-clinic" | "tele";
}) {
  const headers = new Headers();

  headers.append("Content-Type", "application/json");
  headers.append("accept", "application/json");

  const requestBody = JSON.stringify({
    startTime,
    endTime,
    slotDuration,
    clinicId,
    mode,
  });

  const requestOptions: RequestInit = {
    method: "POST",
    headers,
    credentials: "include",
    body: requestBody,
  };

  const url = new URL(
    `/v2/business/doctor/${docId}/custom-slots`,
    GET_TRYST_HOST()
  );

  if (slotsFromCalendar) {
    url.searchParams.set("slots_from_calendar", "true");
  }

  const response = await fetch(url.toString(), requestOptions);

  const customSlotResponse: TrystGenericResponse<{
    slots: (CustomSlot & {
      in_schedule: boolean;
      slots_booked: number;
      is_calendar_blocked: boolean;
      // when CALENDAR_FLOW in genie is tured on. and U send this key to BE in QP
      // slots_from_calendar
      conf_id?: string;
    })[];
    // when CALENDAR_FLOW in genie is tured on. and U send this key to BE in QP
    // slots_from_calendar
    services?: Record<
      string,
      {
        service_name: string;
        duration: number;
        service_id: number;
        price: number | null;
        conf_id: string;
        allow_patient_booking: boolean;
        mode: string[];
      }
    >;
  }> = await response.json();
  const { success, data, error } = customSlotResponse;

  if (!response.ok || !success || !data) {
    throw error || "Failed to fetch slots";
  }

  return data;
}
